import styled from "styled-components";
import colors from "../../theme/color/ColorTheme";
import fontSize from "../../theme/fonts/FontTheme";

const Wrapper = styled.button`
  width: ${(props) => props.$width || "auto"};
  height: 40px;

  border: none;
  padding: 5px ;
  cursor: pointer;

  font-size: ${fontSize.xs};
  text-transform: uppercase;
  letter-spacing: 0.12rem;
  color: white;

  background-color: ${colors.black};
  background-clip: content-box;

  box-shadow: inset 0 0 0 4px ${colors.black};

  transition: background-color 0.25s ease, box-shadow 0.25s ease;

  &:hover {
    background-color: #242424;
    box-shadow: inset 0 0 0 4px #242424;
  }

  @media (max-width: 500px) {
    width: 100%;
  }
`;

function PrimaryButton(props) {
  return (
    <Wrapper $width={props.width} onClick={props.onClick}>
      {props.title}
    </Wrapper>
  );
}

export default PrimaryButton;
